import {
  Document,
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  ITableOptions,
  ITableRowOptions,
  ITableCellOptions,
  IParagraphOptions,
  IRunOptions,
  BorderStyle,
  WidthType,
} from "docx";

export abstract class DocxBase {
  abstract create(data: any): Document;
  div(options: string | IRunOptions) {
    if (typeof options === "string") {
      return new TextRun(options);
    }
    return new TextRun({ break: 1, ...options });
  }
  span(options: string | IRunOptions) {
    return new TextRun(options);
  }
  textRun(options: string | IRunOptions) {
    return new TextRun(options);
  }
  paragraph(options: string | IParagraphOptions) {
    return new Paragraph(options);
  }
  table(options: ITableOptions) {
    return new Table(options);
  }
  tableRow(options: ITableRowOptions) {
    return new TableRow(options);
  }
  tableCell(options: ITableCellOptions) {
    return new TableCell(options);
  }
  bordersNone() {
    return {
      top: {
        style: BorderStyle.NIL,
      },
      bottom: {
        style: BorderStyle.NIL,
      },
      left: {
        style: BorderStyle.NIL,
      },
      right: {
        style: BorderStyle.NIL,
      },
    };
  }
  widthByPercentage(size: string) {
    return {
      size,
      type: WidthType.PERCENTAGE,
    };
  }
}
